import React from 'react';
import { Grid, Container } from '@material-ui/core';
import CabinetBaseLayout from '../../../components/CabinetBaseLayout';
import { StaticChart } from '../../../components/Charts';

const MainView = () => (
  <CabinetBaseLayout>
    <Container maxWidth="xl">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StaticChart />
        </Grid>
      </Grid>
    </Container>
  </CabinetBaseLayout>
);

export default MainView;
